import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { convertDateToUTC } from "../../utility";
import BasicIcons from "../Icons/BasicIcons";

const EventAccordion = ({
  event,
  isGroup,
  children,
  summaryLeadingChildren,
  expanded,
  onChange,
  classes = "",
  showEventDate = false,
  showUserFirstName = false,
  showExpandedIcon = false,
  eventTitle = null,
  isRecapEvents = false,
}) => {
  const isGroupEvent = isGroup;

  return (
    <Accordion className={classes} expanded={expanded} onChange={onChange}>
      <AccordionSummary
        expandIcon={showExpandedIcon && <BasicIcons.ChevronDown size={24} />}
        className="d-flex align-items-center"
      >
        {summaryLeadingChildren && (
          <div className="mr-3">{summaryLeadingChildren}</div>
        )}
        <Typography className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center w-100">
          <div className="accordion-title accordion-title-expanded-color">
            {eventTitle ??
              event?.eventName ??
              event?.subEvents?.find((e) => e?.eventName)?.eventName ??
              event?.othersSubEvents?.find((e) => e?.eventName)?.eventName ??
              "Event Name Not Available"}
            {isGroupEvent &&
              (event?.subEvents?.length || 0) +
                (event?.othersSubEvents?.length || 0) >
                1 &&
              ` - ${
                (event?.subEvents?.length || 0) +
                (event?.othersSubEvents?.length || 0)
              } ${isRecapEvents ? "recaps" : "events"} `}
            {(!isGroupEvent || isRecapEvents) &&
              showEventDate &&
              (() => {
                // Pick event date from main event or fallback sub-events
                const date =
                  event?.eventDate ??
                  event?.subEvents?.find((e) => e?.eventDate)?.eventDate ??
                  event?.othersSubEvents?.find((e) => e?.eventDate)?.eventDate;

                // Pick ianaTimezone from main event or fallback sub-events
                const ianaTimezone =
                  event?.eventLocation?.[0]?.timezone ??
                  event?.subEvents?.find((e) => e?.eventLocation?.length)
                    ?.eventLocation?.[0]?.timezone ??
                  event?.othersSubEvents?.find((e) => e?.eventLocation?.length)
                    ?.eventLocation?.[0]?.timezone;

                return  ` - ${convertDateToUTC(date, ianaTimezone)}`;
              })()}
            {showUserFirstName &&
              ` - ${event?.user?.firstName ?? "Host Name Not Available"}`}
          </div>
          <div className={showExpandedIcon && "mr-2"}>
            <span className="accordion-title">
              {isGroupEvent ? "Group Event ID" : "Event ID"}:
            </span>
            <span className="accordion-title accordion-title-color pl-2">
              {isGroupEvent
                ? event?.eventGroupId
                : event?.id ??
                  event?.subEvents?.find((e) => e?.id)?.id ??
                  event?.othersSubEvents?.find((e) => e?.id)?.id ??
                  event?.eventGroupId ??
                  "Event ID Not Available"}
            </span>
          </div>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default EventAccordion;
